module.exports = __webpack_public_path__ + "img/ff.c2d878aa.jpg";